var exports = {
  "Ap": "ListItemDescriptionItem_0__TlxZTr",
  "fc": "ListItemTitle_0__QrvFBX",
  "mQ": "ListItemTitle_1__qFOIKe",
  "LR": "ListItem_0__gOrnPo",
  "lb": "ListItemDescription_0__VRDf2K",
  "az": "Box__uA4UxD",
};

module.exports = exports;
